import authUser from '~/modules/auth/authUser'
import { userRoles } from '~/modules/auth/constants/common'

export default function ({ redirect, route }) {
  const user = authUser.get()
  const adminAvailableRoles = [
    userRoles.support,
    userRoles.admin,
    userRoles.superAdmin,
    userRoles.manager,
    userRoles.accountant
  ]
  const isAdmin = user?.roles.some(role => adminAvailableRoles.includes(role))
  if (!isAdmin) {
    return redirect({
      path: '/documents'
    })
  }
  if (route.name === 'admin') {
    return redirect({
      path: '/admin/organizations'
    })
  }
}
